import { render, staticRenderFns } from "./LKRoadmapsFeedView.vue?vue&type=template&id=80617e9a&"
import script from "./LKRoadmapsFeedView.vue?vue&type=script&lang=js&"
export * from "./LKRoadmapsFeedView.vue?vue&type=script&lang=js&"
import style0 from "./LKRoadmapsFeedView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports